import { css } from '@emotion/react'
import { Flow, Heading, Icon, Text, Theme, useTheme } from 'bold-ui'

interface NewMessageToastBodyProps {
  sender: string
  content: string
}

export function NewMessageToastBody(props: Readonly<NewMessageToastBodyProps>) {
  const { sender, content } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={styles.container}>
      <Flow direction='horizontal' gap={0.5}>
        <Icon size={1} style={styles.senderIcon} icon='chatFilled' />
        <Heading level={5} style={styles.sender} fontWeight='bold'>
          {sender}
        </Heading>
      </Flow>
      <Text style={styles.message}>{content}</Text>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    width: 18rem;
  `,
  senderIcon: css`
    color: ${theme.pallete.primary.c80};
  `,
  sender: css`
    max-width: 15rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${theme.pallete.gray.c100};
  `,
  message: css`
    color: ${theme.pallete.gray.c100};
    overflow-wrap: break-word;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    display: -webkit-box;
  `,
})
